export default {
    'protokol/storefront': () => import('@/components/integrations/protokol/storefront/events.js'),
    'protokol/media': () => import('@/components/integrations/protokol/media/events.js'),
    'protokol/invoicing': () => import('@/components/integrations/protokol/invoicing/events.js'),
    'protokol/vpfr': () => import('@/components/integrations/protokol/vpfr/events.js'),
    'protokol/ocr': () => import('@/components/integrations/protokol/ocr/events.js'),
    'protokol/clerk': () => import('@/components/integrations/protokol/clerk/events.js')
}